import {
   CheckIcon,
   InteractiveTable,
   InteractiveTableCellProps,
   useInteractiveTableContext,
} from '@dreryk/react-components';

import { DiagnosisTableBean } from '../../DiagnosesFormTab.types';
import { VisitDiagnosisChronicEventInterceptor } from '../interceptors/VisitDiagnosisChronicEventInterceptor';

type ChronicDiseaseCellProps = InteractiveTableCellProps<boolean> & {
   readonly visitId: number;
   readonly chronicEditable: boolean;
};

export const ChronicDiseaseCell = (props: ChronicDiseaseCellProps): JSX.Element => {
   const { getCellValue } = useInteractiveTableContext<DiagnosisTableBean>();

   const code = getCellValue('code', props.index);
   const chronic = getCellValue('chronic', props.index);
   const disabled = !props.chronicEditable;

   return (
      <VisitDiagnosisChronicEventInterceptor visitId={props.visitId} code={code} chronic={chronic} disabled={disabled}>
         <InteractiveTable.ToggleCell
            testId={'chronic'}
            name={'chronic'}
            index={props.index}
            defaultValue={props.defaultValue}
            disabled={disabled}
            icon={<CheckIcon />}
         />
      </VisitDiagnosisChronicEventInterceptor>
   );
};
